import { Component, OnInit } from '@angular/core';
import { BookingService } from 'src/app/services/booking/booking.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { AccountInformationService } from 'src/app/services/account-information/account-information.service';

@Component({
  selector: 'app-booking-requests',
  templateUrl: './booking-requests.page.html',
  styleUrls: ['./booking-requests.page.scss'],
})
export class BookingRequestsPage implements OnInit {
  moment: any = moment;
  s3_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '../../../assets/images/profile-placeholder.png';
  user_profile: any;

  subscription = new SubSink();
  all_booking_requests = null;
  booking_requests = [];

  isStatusLoading: boolean = false;

  constructor(
    private bookingService: BookingService,
    public router: Router,
    private accountInfoService: AccountInformationService,
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
      this.getStatusBookings();
      this.getUserProfileData();
    }

  getStatusBookings() {
    this.subscription.sink = this.bookingService.getStatusBookings().subscribe(
      (res: any) => {
        // console.log("bookings listing --> ",res.data);
        this.all_booking_requests = res.data;
        this.booking_requests = [];
        this.all_booking_requests.forEach(elem => {
          if (elem.customer !== null) {
            this.booking_requests.push(elem);
          }
        });
        // console.log("booking_requests ==> ",this.booking_requests);
      },
      (error) => console.log(error)
    );
  }

  getUserProfileData() {
    this.user_profile = this.accountInfoService.getUserProfile();
    // console.log("user --> ",this.user_profile)
  }

  acceptRequest(id) {
    this.isStatusLoading = true;
    let data = {
      id: id,
      status: "Confirm",
      encoded_user_id: btoa(this.user_profile.id)
    };
    this.changeRequestBookingStatus(data);
  }

  rejectRequest(id) {
    this.isStatusLoading = true;
    let data = {
      id: id,
      status: "Cancel",
      encoded_user_id: btoa(this.user_profile.id)
    };
    this.changeRequestBookingStatus(data);
  }


  changeRequestBookingStatus(data) {
    this.subscription.sink = this.bookingService.changeRequestBookingStatus(data).subscribe(
      (res: any) => {
        // console.log("status change ==> ", res);
        this.isStatusLoading = false;
        this.getStatusBookings();
      },
      (error) => {
        console.log(error);
        this.isStatusLoading = false;
      }
    );
  }


  goToProfile(booking) {
    let account_type = (booking?.customer?.account_type?.id) ? booking?.customer?.account_type?.id : '';
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';
    this.router.navigate([type + '/' + btoa(booking.customer_id)]);
  }


}
